<div>
  <ui-back-button (click)="onClose.emit()"
                  class="d-block my-2"
                  [showTextOnlyOnDesktop]="false"
                  [translateKey]="'common.back'">
  </ui-back-button>
  <div class="text-center">
    <ui-choose-motive-cropper
      [imgUrl]="imgUrl"
      [file]="file"
      [selectedAspectRatio]="selectedAspectRatio"
      [aspectRatios]="aspectRatios"
      [maxImageSize]="maxImageSize"
      (onImgUrlChanged)="imgUrl = $event"
      (onRatioChanged)="selectedAspectRatio = $event"
      (onResultUrlChanged)="resultImgUrl = $event"
      (onFileChosen)="file = $event"
    ></ui-choose-motive-cropper>
  </div>
</div>
<div class="modal-footer justify-content-center border-top-0"
     *ngIf="imgUrl">
  <button class="btn btn-outline-primary"
          type="button"
          (click)="file = null; imgUrl = null;"
          [translate]="'cakeBuilder.cakeMotiveSection.uploadImage.uploadNew'">
  </button>
  <button class="btn btn-pink"
          type="button"
          (click)="uploadImage()"
          [translate]="'cakeBuilder.cakeMotiveSection.uploadImage.confirm'">
  </button>
</div>
